import axios from 'axios'

console.log(process.env)
const instance = axios.create({
    // baseURL: '/',
    baseURL: process.env.NODE_ENV=='production' ? 'https://wh-api.wenhua.com.cn/' : '/',
    timeout: 20000
})

//添加请求拦截数据
instance.interceptors.request.use(
    function (config) {
        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)
//添加响应拦截数据
instance.interceptors.response.use({
    function (response) {
        // console.log(response)
        if (response.data.code !== 200) {
            Message.error(response.data.message)
        }
        return response.data 
    },
    function (error) {
        return Promise.reject(error)
    }
})

const post = (url, data) => {
    return new Promise((resolve, reject) => {
        instance.post(url, data).then((res) => {
                resolve(res.data)
            }).catch((err) => {
                reject(err)
            })
    });
};

export {post};